import React from 'react'
import './Partnerships.css'
import Footer from '../Footer'
import '../../App.css'

function Partnerships() {
  // ---- Customize these in one place ----
  const org = {
    name: 'Delta Sigma Pi – Alpha Pi (Example)',        // your org/chapter name
    directorName: 'Sofia Kantor',                       // director/VP name
    directorTitle: 'VP of Professional Events, Fall 2025',
    contactEmail: 'dspi@iu.edu',                        // replace with your email
    city: 'Bloomington, IN',
  }

  const tiers = [
    {
      name: 'Basic',
      price: '$500 / year',
      highlight: false,
      perks: [
        'Resume book access',
        'Company logo on our website',
        'Company info shared at weekly chapter',
      ],
    },
    {
      name: 'Pro',
      price: '$750 / year',
      highlight: false,
      perks: [
        'Resume book access',
        'Company logo on our website',
        'Company info shared at weekly chapter',
        'Private company event with chapter',
        "Add your company’s info to our alumni network",
      ],
    },
    {
      name: 'Premium',
      price: '$1000 / year',
      highlight: true, // visually emphasized
      perks: [
        'Resume book access',
        'Company logo on our website',
        'Company info shared at weekly chapter',
        'Private company event with chapter',
        "Add your company’s info to our alumni network",
        'Event dedicated to your company during recruitment',
      ],
    },
  ]

  return (
    <div className="partnerships-container">
      {/* HERO */}
      <section className="hero">
        <div className="hero-overlay" />
        <div className="hero-content">
          <div className="hero-badge">Partnerships</div>
          <h1>Partner With Our Chapter</h1>
          <p>
            Engage directly with {org.name.split('–')[0].trim()}’s top business & tech talent. 
            Sponsor events, build your brand on campus, and recruit exceptional students.
          </p>
          <div className="hero-actions">
            <a href="#letter" className="btn btn-outline">Letter from Director</a>
            <a href="#packages" className="btn btn-primary">View Packages</a>
          </div>
        </div>
      </section>

      {/* LETTER */}
      <section id="letter" className="section letter">
        <div className="container">
          <h2 className="section-title">Letter from the Director of Corporate Partnerships</h2>
          <div className="crest" aria-hidden="true">⚜️</div>
          <div className="letter-body">
            <p>Dear Prospective Corporate Partner,</p>
            <p>
              Thank you for considering a partnership with our chapter at {org.city}. 
              We strive to be the bridge between corporate partners and our members throughout the year.
            </p>
            <p>
              Our organization is founded on professionalism, and we live this through our actions, experiences, 
              and achievements. We sponsor events with campus organizations to expand our impact—networking with companies, 
              discussing the importance of corporate social responsibility, and hosting philanthropic initiatives.
            </p>
            <p>
              By partnering with us, your company will gain unique access to a diverse pool of top students across business-related
              majors and backgrounds. Our members are driven to lead and to succeed wherever they go.
            </p>
            <p>
              In the sponsorship details below, you’ll find tiered packages outlining deliverables and engagement options to 
              match your goals. We’re happy to tailor opportunities that make sense for your team.
            </p>
            <p>
              We appreciate your interest and look forward to building a long-lasting relationship with you. 
              For questions, please reach me at <a href={`mailto:${org.contactEmail}`}>{org.contactEmail}</a>.
            </p>
            <div className="signature">
              <div className="sig-name">{org.directorName}</div>
              <div className="sig-title">{org.directorTitle}</div>
            </div>
          </div>
        </div>
      </section>

      {/* PACKAGES */}
      <section id="packages" className="section packages">
        <div className="container">
          <h2 className="section-title">Partnership Packages</h2>

          <div className="tiers">
            {tiers.map(tier => (
              <article
                key={tier.name}
                className={`tier ${tier.highlight ? 'tier--highlight' : ''}`}
                aria-label={`${tier.name} package`}
              >
                <header className="tier-head">
                  <h3>{tier.name}</h3>
                  <div className="price">{tier.price}</div>
                </header>
                <ul className="perk-list">
                  {tier.perks.map((p, i) => (
                    <li key={i} className="perk">
                      <span className="dot" aria-hidden="true" />
                      {p}
                    </li>
                  ))}
                </ul>
                <a href={`mailto:${org.contactEmail}?subject=${encodeURIComponent(tier.name + ' Partnership Inquiry')}`}
                   className="btn btn-primary btn-block">
                  Get {tier.name}
                </a>
              </article>
            ))}
          </div>

          <p className="note">
            Need a custom package? <a href={`mailto:${org.contactEmail}`}>Email us</a>—we’re happy to tailor benefits
            (multi-event series, case workshops, resume drops, coffee chats, and more).
          </p>
        </div>
      </section>

      {/* BRAND STRIP / LOGOS (optional placeholder) */}
      <section className="section brand-strip">
        <div className="container">
          <h4>What partners typically do with us</h4>
          <div className="chips">
            <span className="chip">Resume Drops</span>
            <span className="chip">Coffee Chats</span>
            <span className="chip">Case Workshops</span>
            <span className="chip">Speaker Panels</span>
            <span className="chip">On-Campus Tabling</span>
            <span className="chip">CSR & Philanthropy</span>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section cta">
        <div className="container cta-card">
          <h3>Ready to partner?</h3>
          <p>
            Let’s align on your timeline, event types, and recruiting goals. 
            We can turn around a plan quickly.
          </p>
          <div className="cta-actions">
            <a className="btn btn-primary" href={`mailto:${org.contactEmail}?subject=Partnership Inquiry`}>
              Contact Us
            </a>
            <a className="btn btn-outline" href="#packages">See Packages</a>
          </div>
        </div>
      </section>


    </div>
  )
}

export default Partnerships
